import get from 'lodash/get';
import find from 'lodash/find';

export const createMapEntityToOptions = (config = {}) => {
  const {keyLabel = 'name', keyValue = '_id', space} = config;

  return item => {
    const value = get(item, keyValue);
    const label = get(item, keyLabel);
    const itemSpace = find(space, sp => sp.id === get(item, 'space'));
    return {
      value,
      label: `${label}${!space || !itemSpace ? '' : `${itemSpace.name ? ' - ' + itemSpace.name : ''}`}`
    };
  };
};
